import React, { useEffect, useRef, useState } from 'react';
import { HorizontalTabs } from './HorizontalTabs/index.ts';
import { DropdownTabs } from './DropdownTabs/index.ts';
import styles from './TableTabs.module.scss';
export const TableTabs = (props)=>{
    const [isOverflowing, setIsOverflowing] = useState(false);
    const horizontalRef = useRef(null);
    useEffect(()=>{
        const horizontal = horizontalRef.current;
        if (horizontal == null) return;
        const updateOverflow = ()=>setIsOverflowing(horizontal.scrollWidth > horizontal.clientWidth);
        updateOverflow();
        const observer = new ResizeObserver(updateOverflow);
        observer.observe(horizontal);
        return ()=>observer.disconnect();
    }, [
        props.tabs,
        props.size
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.tableTabs
    }, /*#__PURE__*/ React.createElement(HorizontalTabs, {
        ...props,
        ref: horizontalRef,
        measureOnly: isOverflowing
    }), isOverflowing && /*#__PURE__*/ React.createElement(DropdownTabs, props));
};
